import React from "react";
import { motion } from "framer-motion";

/**
 * PassportBadge — an ink-stamp style badge (circular double border, monospace label).
 */
export function PassportBadge({ label, sub = "STAMP", earned = false, size = 96, testId }) {
  const dim = { width: size, height: size };
  return (
    <motion.div
      data-testid={testId}
      initial={earned ? { scale: 0.7, opacity: 0, rotate: -20 } : false}
      animate={earned ? { scale: [0.7, 1.15, 1], opacity: 1, rotate: -6 } : { opacity: 1 }}
      transition={{ duration: 0.6, type: "spring", stiffness: 220, damping: 14 }}
      style={dim}
      className={
        "relative flex flex-col items-center justify-center rounded-full border-2 font-mono-code select-none " +
        (earned
          ? "border-primary text-primary"
          : "border-border text-muted-foreground opacity-50")
      }
    >
      <div className="absolute inset-1 rounded-full border border-current opacity-60" />
      <span className="text-[9px] uppercase tracking-widest">{sub}</span>
      <span className="text-[11px] font-bold uppercase tracking-tight px-2 text-center leading-tight">
        {label}
      </span>
      <span className="text-[8px] mt-0.5 opacity-70">
        {earned ? "✓ EARNED" : "LOCKED"}
      </span>
    </motion.div>
  );
}
